export const NOTE_MAX_WORD_COUNT = 50;

export const ProfessionalTypePrefix = {
  bather: 'bather',
  groomer: 'groomer',
} as const;

export const ProfessionalExperienceStatus = {
  inTraining: 'in-training',
  noExperience: 'no-experience',
} as const;

export const UNSAVED_CHANGES_DIALOG_CONTENT = {
  title: 'You have unsaved changes',
  message: ' If you leave now, your updates will be lost. Would you like to continue editing?',
  stayText: 'Continue editing',
  goBackText: 'Leave without saving',
};

export const GROOMING_EMERGENCY_PHONE_NUMBER = '833-386-0528';

export const GROOMING_HELP_CENTER_URL =
  'https://support.rover.com/hc/en-us/articles/45572014256788-How-do-I-become-a-groomer-on-Rover';

export const GROOMING_SEARCH_URL = '/grooming/search/';

export const SERVICE_SELECT_URL = '/account/continue/?next=/account/profile/start/';
export const PROVIDER_PROFILE_URL = '/provider-profile/';
